module.exports = ".app-dialog-create-new-schedule .table {\n  display: flex; }\n\n.app-dialog-create-new-schedule .mat-form-field {\n  width: 100px; }\n"